import type { RouteRecordRaw } from 'vue-router';

/**
 * HR employee-core web screens (M6 WP6.1, DECISIONS.md "ADR-067 — HR employee core (WP6.1)"):
 * employees list/detail (profile/sensitive/contracts/documents/organization tabs) and jobs/
 * positions/grades master data. Kept in its own file per the established convention
 * (`manufacturing.ts`/`textile.ts`) — `router.ts` only spreads this array into the app-shell
 * `children`, gated by the `hr` module the same way every other module-gated route group is.
 */
export const hrRoutes: RouteRecordRaw[] = [
  {
    path: 'hr/employees',
    name: 'hr-employees',
    component: () => import('../pages/hr/EmployeesPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/employees/:id',
    name: 'hr-employee-detail',
    component: () => import('../pages/hr/EmployeeDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/jobs',
    name: 'hr-jobs',
    component: () => import('../pages/hr/JobsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/grades',
    name: 'hr-grades',
    component: () => import('../pages/hr/GradesPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/positions',
    name: 'hr-positions',
    component: () => import('../pages/hr/PositionsPage.vue'),
    meta: { requiresModule: 'hr' },
  },

  // ---- Time & attendance (M6 WP6.2, DECISIONS.md "ADR-068 — Time & attendance (WP6.2)") --------
  {
    path: 'hr/attendance/shifts',
    name: 'hr-attendance-shifts',
    component: () => import('../pages/hr/attendance/ShiftsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/shifts/:id',
    name: 'hr-attendance-shift-detail',
    component: () => import('../pages/hr/attendance/ShiftDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/rotations',
    name: 'hr-attendance-rotations',
    component: () => import('../pages/hr/attendance/RotationsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/assignments',
    name: 'hr-attendance-assignments',
    component: () => import('../pages/hr/attendance/ShiftAssignmentsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/punch-import',
    name: 'hr-attendance-punch-import',
    component: () => import('../pages/hr/attendance/PunchImportPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/board',
    name: 'hr-attendance-board',
    component: () => import('../pages/hr/attendance/AttendanceBoardPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/days/:id',
    name: 'hr-attendance-day-detail',
    component: () => import('../pages/hr/attendance/AttendanceDayDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/attendance/approvals',
    name: 'hr-attendance-approvals',
    component: () => import('../pages/hr/attendance/AttendanceApprovalInboxPage.vue'),
    meta: { requiresModule: 'hr' },
  },

  // ---- Leave (M6 WP6.3, DECISIONS.md "ADR-069 — Leave management (WP6.3)") -----------------------
  {
    path: 'hr/leave/types',
    name: 'hr-leave-types',
    component: () => import('../pages/hr/leave/LeaveTypesPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/policies',
    name: 'hr-leave-policies',
    component: () => import('../pages/hr/leave/LeavePoliciesPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/balances',
    name: 'hr-leave-balances',
    component: () => import('../pages/hr/leave/LeaveBalancesPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/calendars',
    name: 'hr-leave-calendars',
    component: () => import('../pages/hr/leave/LeaveCalendarsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/accrual-runs',
    name: 'hr-leave-accrual-runs',
    component: () => import('../pages/hr/leave/LeaveAccrualRunsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/my-requests',
    name: 'hr-leave-my-requests',
    component: () => import('../pages/hr/leave/MyLeaveRequestsPage.vue'),
    meta: { requiresModule: 'hr' },
  },
  {
    path: 'hr/leave/approvals',
    name: 'hr-leave-approvals',
    component: () => import('../pages/hr/leave/LeaveApprovalInboxPage.vue'),
    meta: { requiresModule: 'hr' },
  },
];
